import type { FieldProvenanceDto } from '@@types/api.types';
import { FieldProvenanceBadge } from '@components/shared/field-provenance-badge.component';
import React, { ReactNode } from 'react';

type SectionHeaderProps = {
  children?: ReactNode;
  provenance?: FieldProvenanceDto | null;
  title: string;
};

export const TechnologyMissionAssessmentSectionHeaderComponent: React.FC<SectionHeaderProps> = (props) => {
  const { children, provenance, title } = props;

  return (
    <div className="flex flex-col gap-y-4">
      <div className="flex items-center gap-2 text-xs text-[#1F1C1AB2] font-normal">
        {title}
        <FieldProvenanceBadge provenance={provenance} />
      </div>
      {children && <div>{children}</div>}
    </div>
  );
};
